// extracted by mini-css-extract-plugin
export default {"formGroup":"profile_formGroup__fRx8v","profileTop":"profile_profileTop__pWPcj","editBtn":"profile_editBtn__hgdNc","addCompany":"profile_addCompany__8f59w"};